import React from "react";
import { PoweroffOutlined } from "@ant-design/icons";
import { usePageTheme } from "../theme/usePageTheme";

interface V2CloseSessionButtonProps {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
  "aria-label"?: string;
}

/** 关闭会话 — 圆形电源键，背景随主题用户渐变色 */
const V2CloseSessionButton: React.FC<V2CloseSessionButtonProps> = ({
  onClick,
  disabled = false,
  title,
  "aria-label": ariaLabel,
}) => {
  const { tokens } = usePageTheme();

  return (
    <button
      type="button"
      className="uchat-v2-close-session-btn"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel}
      style={{
        background: `linear-gradient(135deg, ${tokens.chatUserGradientStart}, ${tokens.chatUserGradientEnd})`,
        boxShadow: `0 6px 18px ${tokens.chatUserGradientStart}47`,
      }}
    >
      <PoweroffOutlined />
    </button>
  );
};

export default V2CloseSessionButton;
